export enum SectionKind {
  Closed = 'closed',
  Open = 'open',
}

export interface QuestionForm {
  id: string;
  text: string;
}

export interface SectionForm {
  id: string;
  title: string;
  description?: string;
  kind: SectionKind;
  questions: QuestionForm[];
}
